// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"2":"60c3326b","8":"20f77126","421":"86e5800b","467":"1983ff42","484":"70039480","596":"b34a49ce","787":"9fda8c43","869":"78f926de"}[chunkId] + ".chunk.js";
};